module.exports = __webpack_public_path__ + "static/media/sound-from-office.e9107690.mp3";